import { watch, reactive } from 'vue'
import merge from 'deepmerge'
import { isTokenExpired } from '../useAuthorizedUsers'
import store from '@/composables/useZeroWidgetStore/methods'
import { configConstants } from '@/constants'

export const saveOnLocalStorage = (data: { [key: string]: string }) => {
  localStorage.setItem('localStorageState', JSON.stringify(data))
}

export const getLocalStorageState = () => {
  return localStorage.getItem('localStorageState')
}

export const createPersistedState = (state: any, statesToPersist: { [key: string]: any }) => {
  let localStorageState = getLocalStorageState()
  if (!localStorageState) {
    saveOnLocalStorage(JSON.parse(JSON.stringify(statesToPersist)))
    localStorageState = getLocalStorageState()
  }

  const reactivePersistedState = reactive(JSON.parse(localStorageState as string))

  const reactiveState = reactive({
    ...state,
    ...JSON.parse(localStorageState as string)
  })
  let resultantsStore = reactiveState
  watch(reactiveState, () => {
    const persistedStateArrays = Object.keys(statesToPersist)
    for (let value of persistedStateArrays) {
      reactivePersistedState[value] = reactiveState[value]
    }
    saveOnLocalStorage(reactivePersistedState)
    const valueSaved = getLocalStorageState()
    resultantsStore = merge(reactiveState, JSON.parse(valueSaved as string))
  })

  return resultantsStore
}

interface IOptions {
  countryCode: string
  showEmptyDecimal: boolean
  displayCurrencyAs: string
  officialLanguage: string
}
const getCountryCurrency = (countryCode: string) => {
  const countryCodeList = {
    ng: 'NGN',
    ke: 'KES',
    gh: 'GHC'
  } as { [key: string]: string }
  return countryCodeList[countryCode]
}
export const moneyFormatter = (amount: number, options: IOptions) => {
  if (!amount) {
    amount = 0
  }
  options.countryCode = String(options.countryCode).toUpperCase()

  const formatOptions = {} as { [key: string]: any }

  Object.assign(formatOptions, options, {
    currencyDisplay: options.displayCurrencyAs
  })
  formatOptions.currency = getCountryCurrency(options.countryCode.toLowerCase())
  formatOptions.style = 'currency'
  if (options.showEmptyDecimal) {
    formatOptions.minimumFractionDigits = 2
  } else {
    formatOptions.maximumFractionDigits = 0
  }

  const { displayCurrencyAs, showEmptyDecimal, countryCode, officialLanguage, ...filteredOptions } = formatOptions

  const formatter = new Intl.NumberFormat(`${officialLanguage}-${countryCode}`, { ...filteredOptions })
  return formatter.format(amount)
}

export const getToken = () => {
  const token = store.state.userToken
  return token
}

export const checkTokenExpiry = () => {
  const token = getToken()
  if (!token) {
    store.actions.setComponent('login')
  }
  const getTokenState = isTokenExpired(token) as boolean
  store.actions.setTokenExpiry(getTokenState)
}

const iconModules = () => {
  const icons = Object.entries(svgIcons).concat(Object.entries(pngIcons))

  const resolvedIconModules = icons.map((module: { [key: string]: any }) => {
    const key = module[0].split('/').at(-1).split('.').at(0)
    const value = module[1]
    return [key, value]
  })

  const hashedModules = resolvedIconModules.reduce((modules: any, entry) => {
    const key = entry[0]
    const value = entry[1]
    if (!!modules[key]) {
      return
    } else {
      modules[key] = value
    }
    return modules
  }, {})
  return hashedModules
}

const svgIcons = import.meta.glob('../../assets/icons/*.svg')
const pngIcons = import.meta.glob('../../assets/icons/*.png')

export const userCardIcon = async (cardBrand: string) => {
  switch (cardBrand) {
    case 'verve':
      return await iconModules().VerveLogo()
    case 'master':
      return await iconModules().MasterLogo()
    case 'visa':
      return await iconModules().VisaLogo()
    default:
      return await iconModules().MasterLogo()
  }
}

// Determine Base URL

export const getBaseUrl = (env: string) => {
  let result = ''
  switch (env) {
    case 'live':
      result = configConstants.productionURL
      break
    case 'test':
      result = configConstants.stagingURL
      break
    default:
      result = 'NO_API_KEY'
      break
  }
  return result
}

// Get date ordinal

export const getDateOrdinal = (day: number) => {
  let ordinal = ''
  switch (day) {
    case 1 || 21 || 31:
      ordinal = 'st'
      break
    case 2 || 22:
      ordinal = 'nd'
      break
    case 3 || 23:
      ordinal = 'rd'
      break
    default:
      ordinal = 'th'
      break
  }
  return ordinal
}
